'use client';

export const ChevronDown = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M15.9979 20.8294L27.1443 9.32548C27.3572 9.10555 27.6131 8.99708 27.9122 9.00006C28.2114 9.00279 28.4675 9.11413 28.6804 9.33406C28.8935 9.55374 29 9.81803 29 10.1269C29 10.4356 28.8935 10.6999 28.6804 10.9198L17.6397 22.3063C17.4064 22.5471 17.1463 22.7229 16.8593 22.8337C16.572 22.9446 16.2849 23 15.9979 23C15.7108 23 15.4237 22.9446 15.1365 22.8337C14.8495 22.7229 14.5893 22.5471 14.356 22.3063L3.31536 10.9109C3.10227 10.6912 2.99717 10.4284 3.00006 10.1225C3.00271 9.81654 3.11058 9.55374 3.32366 9.33406C3.53651 9.11412 3.79258 9.00416 4.09187 9.00416C4.39092 9.00416 4.64699 9.11412 4.86008 9.33406L15.9979 20.8294Z"
				fill="currentColor"
			/>
		</svg>
	);
};
